import type { ApiConfig } from '@/providers/ApiConfigProvider';
import type { CurrencyApi } from '@/types/api/companies';

interface ErpCurrencyDto {
  id: number;
  code: string;
  name: string;
  symbol: string | null;
}

export async function fetchErpCurrencies(
  apiConfig: Pick<ApiConfig, 'apiBaseUrl' | 'getHeaders'>,
  linkedSubscriptionId: string,
  linkedProductId: string,
  signal?: AbortSignal,
): Promise<CurrencyApi[]> {
  const params = new URLSearchParams({ linkedSubscriptionId, linkedProductId });
  const url = `${apiConfig.apiBaseUrl}/api/v1/currencies/integration?${params.toString()}`;
  const headers = await apiConfig.getHeaders();

  const response = await fetch(url, { method: 'GET', headers, signal });
  if (!response.ok) {
    throw new Error(`ERP currencies request failed with status ${response.status}`);
  }

  const result: ErpCurrencyDto[] = await response.json() as ErpCurrencyDto[];
  return result.map((c) => ({ id: c.id, code: c.code, name: c.name, symbol: c.symbol }));
}
